import { FC, PropsWithChildren } from 'react';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { ROUTES } from 'config';
import { RecognitionsDisabledFeatureAlert } from 'containers/recognitions';
import { useMe } from 'state/Administrators';

export const RecognitionsLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const { isFeatureEnabled, hasViewPermission } = useMe();

  return (
    <Stack gap={2}>
      <RecognitionsDisabledFeatureAlert />

      <PageHeaderLayout
        breadcrumbs={[{ label: t('recognition.recognitionSettings') }]}
      />

      <PageContentLayout
        sidebar={
          <Stack gap={2}>
            <SideMenu
              tabs={[
                {
                  key: 'recognitions',
                  label: t('recognition.recognitionFeed'),
                  url: ROUTES.recognitions.list,
                  isActive: path === ROUTES.recognitions.list,
                },
                {
                  key: 'comments',
                  label: t('comments.title'),
                  url: ROUTES.recognitions.comments.list,
                  isActive: path === ROUTES.recognitions.comments.list,
                },
                ...(hasViewPermission(['employees'])
                  ? [
                      {
                        key: 'recipients',
                        label: t('common.recipients'),
                        url: ROUTES.recognitions.recipients.list,
                        isActive:
                          path === ROUTES.recognitions.recipients.list ||
                          path === ROUTES.recognitions.leaderboard.list,
                      },
                      {
                        key: 'givers',
                        label: t('recognition.giversTab'),
                        url: ROUTES.recognitions.givers.list,
                        isActive: path === ROUTES.recognitions.givers.list,
                      },
                      {
                        key: 'allocations',
                        label: t('recognition.allowancesOverviewTab'),
                        url: ROUTES.recognitions.allocations.list,
                        isActive: path === ROUTES.recognitions.allocations.list,
                      },
                    ]
                  : []),
              ]}
            />
            <SideMenu
              tabs={[
                {
                  key: 'settings',
                  label: t('common.settings'),
                  url: ROUTES.recognitions.settings,
                  isActive: path === ROUTES.recognitions.settings,
                },
                {
                  key: 'achievements',
                  label: t('recognition.achievementsTab'),
                  url: ROUTES.recognitions.achievements.list,
                  isActive: path === ROUTES.recognitions.achievements.list,
                },
                {
                  key: 'rules',
                  label: t('recognition.allowanceRulesTab'),
                  url: ROUTES.recognitions.rules.list,
                  isActive: path === ROUTES.recognitions.rules.list,
                },
                isFeatureEnabled('marketplaceV2')
                  ? {
                      key: 'brands',
                      label: t('recognition.rewardsTab'),
                      url: ROUTES.recognitions.brands.list,
                      isActive: path === ROUTES.recognitions.brands.list,
                    }
                  : {
                      key: 'rewards',
                      label: t('recognition.rewardsTab'),
                      url: ROUTES.recognitions.rewards.list,
                      isActive: path === ROUTES.recognitions.rewards.list,
                    },
              ]}
            />
          </Stack>
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
